import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import Cookies from "universal-cookie";
import { editDeleteStyles } from "../../../globals";
import Modal from "../../Modal/Modal";
import STSComponent from "../../STSComponent/STSComponent";

class DeleteModal extends STSComponent {
  constructor(props) {
    super(props);
    this.state = {
      showAgain: true,
    };
    this.toggleSwitcher = this.toggleSwitcher.bind(this);
  }

  toggleSwitcher = (cookies) => () => {
    const { toggleSign } = this.props;
    cookies.set(
      `user-${localStorage.getItem("userName")}`,
      "delete modal is hidden"
    );
    if (toggleSign) {
      localStorage.setItem(`delete-${toggleSign}`, true);
    }
    return this.setState({
      showAgain: !this.state.showAgain,
    });
  };

  render() {
    const {
      title,
      toDelete,
      toCancel,
      deleteText,
      toggleBtn,
      modal,
    } = this.props;
    const cookies = new Cookies();

    return (
      <Modal
        modalType={`Delete-${title}`}
        contentLabel={`Delete-${title}`}
        customStyles={editDeleteStyles.delete}
        modal={modal}
      >
        <FontAwesomeIcon
          className="get-report-modals-warning"
          icon={faExclamationTriangle}
          alt="warning icon"
        />
        <div className="get-report-modals-d-textarea">
          Are you sure want to delete this {deleteText || "record"}?
        </div>
        <div className="get-report-modals-buttons-area">
          <button onClick={toDelete}>Delete</button>
          <button onClick={toCancel}>Cancel</button>
        </div>
        {toggleBtn || toggleBtn !== undefined ? (
          <div
            className="switcher-modal"
            onClick={this.toggleSwitcher(cookies)}
          >
            <div className="switch-wrap">
              {this.state.showAgain ? (
                <div className="switch-btn disabled" />
              ) : (
                <div className="switch-btn enabled" />
              )}
              <span className="switch-button-text">Don&apos;t ask again</span>
            </div>
          </div>
        ) : null}
      </Modal>
    );
  }

  static propTypes = {
    title: PropTypes.string,
    toCancel: PropTypes.func,
    toDelete: PropTypes.func,
    deleteText: PropTypes.string,
    toggleBtn: PropTypes.bool,
    toggleSign: PropTypes.string,
    modal: PropTypes.object,
  };
}

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/Modal/components/DeleteModal.js